import React from 'react';
import Helmet from 'react-helmet';

import withPageComponents from '../page/components/with-page-components';
import { Helpers } from '../core';

const validateJSONLD = jsonLD => {
    try {
        return JSON.parse(Helpers.purifyHTML(jsonLD));
    } catch (e) {
        return null;
    }
};

export default withPageComponents(
    ({ jsonLDMarkup }) => {
        const { html } = jsonLDMarkup || {};
        const jsonLD = validateJSONLD(html);
        if (!jsonLD) {
            return null;
        }
        return (
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(jsonLD)}</script>
            </Helmet>
        );
    },
    { components: ['jsonLDMarkup'] },
);
